import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { manualLogin, signUp, toggleLoginMode } from 'modules/user';
import styles from 'css/components/login';
import hourGlassSvg from 'images/hourglass.svg';
import Button from 'react-bootstrap/lib/Button';
import {browserHistory} from 'react-router';
import {FormattedMessage, injectIntl} from 'react-intl';
import Cookies from 'universal-cookie';
const universalCookies = new Cookies();
const cx = classNames.bind(styles);

class LoginOrRegister extends Component {
  constructor(props) {
    super(props);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.state = {
      shopName: universalCookies.get('gc-invoice-browse-shop-name') || null,
      showShopName: true,
      shopifyErr: false
    }
  }

  handleOnSubmit(event) {
    event.preventDefault();

    const { manualLogin, signUp, user: { isLogin }, intl } = this.props;
    const email = ReactDOM.findDOMNode(this.refs.email).value;
    const password = ReactDOM.findDOMNode(this.refs.password).value;

    if (isLogin) {
      manualLogin({ email, password }, intl.locale);
    } else {
      signUp({ email, password }, intl.locale);
    }
  }

  
  componentDidMount () {
    const paddleScript = document.createElement("script");

    paddleScript.src = "https://cdn.paddle.com/paddle/paddle.js";
    document.head.appendChild(paddleScript);

    paddleScript.onload = ()=>{
      const paddelInitScript = document.createElement("script");
      paddelInitScript.async =  true;
      paddelInitScript.innerHTML = `Paddle.Setup({
        vendor: 30421
      });`
    

      document.body.appendChild(paddelInitScript);
    }

    setTimeout(()=>{
      this._shopifyInput.focus();
    }, 200);
  }

  renderHeader() {
    const { user: { isLogin }, toggleLoginMode } = this.props;

    if (isLogin) {
      return (
        <div className={cx('header')}>
          <h1 className={cx('heading')} style={{fontFamily: 'Open Sans'}}><img style={{borderRadius:'4px', boxShadow: '1px 1px 1px 0px #5b4db5'}} src="/img/logo.png" height="32px"></img></h1>
          <h4 style={{textAlign: 'center'}}>{this.state.showShopName? <FormattedMessage id="login.enterShopAddress" /> : <FormattedMessage id="login.loginWith" />}</h4>
        </div>
      );
    }

    return (
      <div className={cx('header')}>
        <h1 className={cx('heading')}><FormattedMessage id="login.createAccount" /></h1>
        <div className={cx('alternative')}>
          
          <a
            className={cx('alternative-link')}
            onClick={toggleLoginMode}
          ><i className="fa fa-arrow-circle-o-left" aria-hidden="true"></i>&nbsp;<FormattedMessage id="loginOrRegister.haveAccount"/></a>
        </div>
      </div>
    );
  }

  submit(e){
    e.preventDefault();
    if (!this.state.shopName){

      if (this.state.showShopName){
        this.setState({
          shopifyErr: true
        })
      }                  

      this.setState({
        showShopName: true
      })

    

    }
    else{
      var date = new Date();
      // Get unix milliseconds at current time plus number of days
      date.setTime(+ date + (1 * 86400000)); //24 * 60 * 60 * 1000

      universalCookies.set(`gc-invoice-browse-shop-name`, this.state.shopName, {
          expires : date
      })

      location.href = `/auth/sp?shop=${this.state.shopName}`;
    }
  }

  render() {
    const { isWaiting, message, isLogin } = this.props.user;
    const { toggleLoginMode } = this.props;

    return (
      <form onSubmit={this.submit.bind(this)}>
       <style>
          {`
            body{
              background-color: #08213e;
            }
            .navbar{
              display:none;
            }
            .layout-nav{
              display:none;
            }
          `}
         </style>
        <div
          className={cx('login', {
            waiting: isWaiting
          })}
        >
          <div>
            { this.renderHeader() }

            <div className={cx('google-container')}>
            <input ref={(i)=>{this._shopifyInput = i}} placeholder={this.props.intl.formatMessage({ id: 'login.placeholder' })} defaultValue={this.state.shopName}  style={{
              borderColor: this.state.shopifyErr ? 'red' : '#c3c8ce'
            }} className={cx('input') + (this.state.showShopName? '' : ' hidden')} onChange={(e)=>{
                this.setState({
                shopName: e.target.value.replace(/\s/g, '')
              })}} type="text"></input>
              <div style={{position:'absolute', right:'22px', top:'28px'}}>.myshopify.com</div>
              {this.state.shopifyErr&& <label style={{color:'red'}}><FormattedMessage id="login.shopRequired" /></label>}
              {this.state.shopifyErr&&<br/>}
              <Button type="submit" bsSize="lg" bsStyle="success" onClick={ this.submit.bind(this) }><i className="fa fa-shopping-cart"></i>&nbsp;{this.state.showShopName? <FormattedMessage id="login.login" /> : 'Shopify'}</Button>
              
            </div>            
            <div style={{textAlign: 'center'}}>
              <a style={{fontSize:'10px', color: 'grey'}} href="https://www.growth-connections.com/terms-and-conditions/" target="_blank"><FormattedMessage id="login.terms" /></a>{"   "}
              <a style={{fontSize:'10px', color: 'grey'}} href="https://www.growth-connections.com/privacy-policy/" target="_blank"><FormattedMessage id="login.privacy" /></a>
            </div>
            {/* { isLogin? 
            (<div className={cx('alternative')}><FormattedMessage id="loginOrRegister.noAccount"/>&nbsp;
              <a className={cx('alternative-link')} onClick={toggleLoginMode}><FormattedMessage id="loginOrRegister.registerButton"/></a>
            </div>) : <div></div>
            } */}
          </div>
        </div>
        </form>
    );
  }
}

LoginOrRegister.propTypes = {
  user: PropTypes.object,
  manualLogin: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
  toggleLoginMode: PropTypes.func.isRequired
};

// Function passed in to `connect` to subscribe to Redux store updates.
// Any time it updates, mapStateToProps is called.
function mapStateToProps({user}) {
  return {
    user
  };
}

// Connects React component to the redux store
// It does not modify the component class passed to it
// Instead, it returns a new, connected component class, for you to use.
export default injectIntl(connect(mapStateToProps, { manualLogin, signUp, toggleLoginMode })(LoginOrRegister));


// WEBPACK FOOTER //
// app/containers/LoginOrRegister.jsx